module.exports = __webpack_public_path__ + "img/raise_green.ce9c5867.png";